var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[(_vm.isLogin)?_c('SingIn',{on:{"toggleRegisterPage":_vm.toggleRegisterPage}}):_vm._e(),(_vm.isRegister)?_c('Register',{on:{"toggleLoginPage":_vm.toggleLoginPage}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }